<template>
    <div class="row">
        <div class="col-12 text-center mt-3">
            <h2 class="segment-primary-color" v-if="totalPayments"> {{ currencyFormat(totalPayments) }}</h2>
            <div v-else-if="loading" class="row d-flex font-weight-bolder justify-content-center mt-2">
                <i class="fa fa-spinner fa-pulse fa-3x fa-fw mt-4"></i>
            </div>
            <span v-if="hasPayments">VALOR TOTAL DAS {{ payments.length }} PARCELAS PAGAS</span><br>
            <span v-if="hasPayments" style="font-size: 11px; color: #f76363;">Conforme procedimento bancário, a
                compensação de boletos está prevista para ocorrer em até 72 horas úteis</span>
            <div v-if="!loading && !hasPayments" class="mb-4">
                <span class="segment-primary-color font-weight-bolder mb-4" style="font-size: 15px;">SEM PARCELAS
                    FUTURAS</span>
            </div>
            <div v-if="totalPayments" class="mt-4 d-flex justify-content-center">
                <button type="button" @click="visible = true"
                    class="btn custom-btn bg-segment-primary-color btn-sm">Solicitar
                    extrato por e-mail</button>
            </div>
            <div v-if="temSegundaVia" class="mt-3 mx-4 p-3" style="background-color: rgba(255, 152, 0, 0.15); border-radius: 10px;">
                <span class="font-weight-bold" style="color: rgba(180, 100, 0, 1); font-size: 13px;">
                    Você possui uma segunda via em aberto. Verifique na aba de parcelas Futuras.
                </span>
            </div>
        </div>
        <div v-if="hasPayments" class="mt-2 d-flex justify-content-center mb-2 ms-2">
            <table class="table align-items-center mb-0">
                <thead>
                    <tr class="mb-2 ms-2">
                        <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Parcela</th>
                        <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Valor</th>
                        <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Vencimento</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="payment in payments" :key="payment.par_in_codigo">
                        <td>
                            <div class="d-flex px-2 py-1">
                                <div class="d-flex flex-column justify-content-center">
                                    <h6 class="mb-0 text-xs">{{ payment.par_in_codigo }}</h6>
                                    <p class="text-xs text-secondary mb-0">PAGA</p>
                                </div>
                            </div>
                        </td>
                        <td>
                            <span class="text-xs font-weight-bold mb-0">{{ currencyFormat(payment.valorpago) }}</span>
                        </td>
                        <td>
                            <p class="text-xs font-weight-bold mb-0">{{ formatDate(payment.par_dt_vencimento) }}</p>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <Dialog v-model:visible="visible" modal header="Extrato completo" :style="{ width: '25rem' }">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 mt-2 mt-sm-0">
            <label>Enviar boleto para</label>
            <argon-input id="mail" v-model="email" class="multisteps-form__input" type="text"
                placeholder="mail@mail.com.br" />
        </div>
        <div class="mt-4 d-flex justify-content-center">
            <button type="button" @click="sendExtract()" :disabled="loadingRequestExtract"
                class="btn custom-btn bg-segment-primary-color text-center d-flex justify-content-center">Confirmar <i
                    v-if="loadingRequestExtract" class="fa fa-spinner fa-pulse fa-fw"></i>
            </button>
        </div>
    </Dialog>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import { useStore } from "vuex";
import { showToast } from "@/assets/js/toast.js";
// import TodoListCard from "./TodoListCard.vue";
import axios from "axios";
import moment from 'moment';
import Dialog from 'primevue/dialog';
import ArgonInput from "@/components/ArgonInput.vue";


const loading = ref(true);
const loadingRequestExtract = ref(false);
const store = useStore();
const payments = ref([]);
const totalPayments = ref(0);
const contractData = computed(() => store.getters.getCurrentContract);
const hasPayments = computed(() => payments.value && payments.value.length > 0);
const temSegundaVia = ref(false);

const checkSegundaVia = async () => {
    try {
        const res = await axios.get(`/contract-ws/${contractData.value.contrato_id}/plots-count`);
        if (res.data?.result?.parcelas?.segunda_via > 0) {
            temSegundaVia.value = true;
        }
    } catch (e) { /* ignore */ }
};
const visible = ref(false);
const email = ref('');

onMounted(async () => {
    checkSegundaVia();
    getNextPayments();
});

/**
 * @TODO
 * backend deve enviar essa requisição para a fila, para nao demorar na resposta
 */
const sendExtract = async () => {

    const data = {
        fil_in_codigo: contractData.value.id_filial,
        cod_ct: contractData.value.contrato_id,
        email: email.value
    };
    
    try {
        loadingRequestExtract.value = true
        const response = await axios.post(`/clients/contract/extract-parcels-complete`, data);
        showToast(response.data.message, 'success');
    } catch (error) {
        console.error(error);
        showToast('Não foi possivel enviar o extrato, tente novamente', 'error');
    } finally {
        loadingRequestExtract.value = false
        visible.value = false
    }
}

const getNextPayments = async () => {
    try {
        const response = await axios.get(`/clients/contract/${contractData.value.contrato_id}/plots?status=PAGAS`);
        payments.value = response.data;
        sumTotalNextPayments();
        loading.value = false;
    } catch (error) {
        console.error(error);
    }
};

const currencyFormat = (value, currency = false) => {
    const options = {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    };

    const formattedValue = new Intl.NumberFormat('pt-BR', options).format(value);

    if (currency) {
        return `${formattedValue}`;
    }

    return formattedValue;
};

const sumTotalNextPayments = () => {
    totalPayments.value = payments.value.reduce((acc, payment) => acc + parseFloat(payment.valorpago), 0);
};

const formatDate = (date) => {
    return moment(date).format('DD/MM/YYYY');
};
</script>

<style>
.bg-color {
    background-color: #ededed !important;
}
</style>
